module.exports = __webpack_public_path__ + "static/logos/whiteroom_logo--white-14751ad2cd170557d6aefdc8cea987db.svg";